// Deterministic first-paint for prerendered routes (Bloque 2B — FASE 1).
//
// PROBLEM: Framer Motion entrance animations (initial -> animate) apply non-deterministic inline
// styles (opacity/transform mid-flight). A prerendered DOM snapshot can never match the client's
// first hydration render, causing React #418.
//
// SOLUTION: skip ONLY the entrance animation on the very first render/hydration of a prerendered
// route, so the first client paint equals the prerendered HTML byte-for-byte. Two independent
// signals turn the skip on, and it is scoped to that first paint only:
//   * window.__RITUAL_PRERENDER__      -> true during the Puppeteer capture (the snapshot itself).
//   * window.__RITUAL_HYDRATING__      -> set true by index.js immediately before hydrateRoot(),
//                                          and cleared right after this hook's component mounts.
// After mount the signal is off, so SPA navigations, route changes and later-appearing elements
// animate normally. Framer Motion is neither removed nor permanently altered.
import { useState, useEffect } from "react";

function computeInitialSkip() {
  if (typeof window === "undefined") return false;
  return window.__RITUAL_PRERENDER__ === true || window.__RITUAL_HYDRATING__ === true;
}

export function useEntranceDisabled() {
  // Read once, at the first render, so capture and hydration make the SAME decision.
  const [disabled] = useState(computeInitialSkip);
  useEffect(() => {
    // Mounted: re-enable entrance animations for every subsequent mount (SPA nav, later elements).
    if (typeof window !== "undefined") window.__RITUAL_HYDRATING__ = false;
  }, []);
  return disabled;
}
